import type { OrganizationMembershipHistoryRow } from '../../data/types';
import { OrganizationMembershipHistoryTable } from '../../permissions/components';

import { CollapsibleCard } from './collapsible-card';

type Props = Readonly<{
  history: OrganizationMembershipHistoryRow[];
  isLoading: boolean;
  showHistory: boolean;
  onToggleHistory: () => void;
  showUserColumn: boolean;
  titleKey: string;
  isPending?: boolean;
  totalCount?: number;
  page?: number;
  pageSize?: number;
  onPaginationChange?: (page: number, pageSize: number) => void;
}>;

export const MembershipHistoryCard = ({
  history,
  isLoading,
  showHistory,
  onToggleHistory,
  showUserColumn,
  titleKey,
  isPending = false,
  totalCount,
  page,
  pageSize,
  onPaginationChange
}: Readonly<Props>) => (
  <CollapsibleCard
    titleKey={titleKey}
    isExpanded={showHistory}
    onToggle={onToggleHistory}
    disabled={isLoading || isPending}
  >
    <OrganizationMembershipHistoryTable
      history={history}
      isLoading={isLoading}
      showUserColumn={showUserColumn}
      rowCount={totalCount}
      page={page}
      pageSize={pageSize}
      onPaginationChange={onPaginationChange}
    />
  </CollapsibleCard>
);
